/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import Form from "react-bootstrap/Form";
import bg from "../img/bg.png";
import "./PageLogin.css";
import "../components/style.css";
import ModalScore from "../components/ModalScore";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import Swal from "sweetalert2";
import { Table } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
// import ModalReport from "../components/ModalReport";
import {
  scrollToElement,
  checkGroupsUser,
  getlocalStorage,
  handleResizeDisplay,
} from "../function/functionALL";
import LoadingTable from "../components/LoadingTable";
import ModalPagination from "../components/ModalPagination";
import CheckNoContent from "../components/CheckNoContent";
import Layout from "../components/Layout";

const PageScoreUser = () => {
  const navigate = useNavigate();
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;
  const [User, setUser] = useState([]);
  const [paginationNext, setpaginationNext] = useState([]);
  const [AmoutData, setAmoutData] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [isStacked, setIsStacked] = useState(false);
  const [search, setSearch] = useState("");
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [loadingTable, setloadingTable] = useState(true); ////ทำงาน
  const topRef = useRef(null);

  useEffect(() => {
    if (search.length === 0) {
      handleResizeDisplay(setIsStacked);
      fetchData();
      setPageNumber(1);
    }
  }, [search]);

  const fetchData = async () => {
    try {
      scrollToElement(topRef);

      setloadingTable(true);
      const response = await Axios.get(process.env.REACT_APP_API_USERS, {
        headers: {
          Authorization: "Token " + Token,
        },
      });

      const sortedData = response.data.results.sort(
        (a, b) => a.rank_id - b.rank_id
      );
      setUser(sortedData);
      setpaginationNext(response.data);
      setAmoutData(response.data.count);
      setloadingTable(false);
    } catch (err) {
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      }
      console.error(err);
      Swal.fire({
        icon: "error",
      });
    }
  };

  const AmountPage = Math.ceil(AmoutData / 25);

  const searchValue = async (e) => {
    e.preventDefault();
    if (search.length < 3) {
      Swal.fire({
        icon: "warning",
        title: "กรุณาค้นหา 3 ตัวอักษรขึ้นไป",
      });
      return;
    }

    try {
      setLoadingSearch(true);
      setloadingTable(true);
      const response = await Axios.get(
        `${process.env.REACT_APP_API_USERS}?search=${search}`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      );
      if (!response.data.results || response.data.results.length === 0) {
        setUser([]);
        setLoadingSearch(false);
        setloadingTable(false);
      } else {
        setLoadingSearch(false);
        setUser(response.data.results);
        setloadingTable(false);
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      }

      console.error(err);
      Swal.fire({
        icon: "error",
      });
    }
  };

  const handlePageChange = (pageNumber) => {
    setPageNumber(pageNumber);
    setloadingTable(true);
    //เลื่อนขึ้นไปดานบน
    scrollToElement(topRef);

    if (pageNumber === 1) {
      Axios.get(process.env.REACT_APP_API_USERS, {
        headers: {
          Authorization: "Token " + Token,
        },
      })
        .then((res) => {
          res.data.results.sort(function (a, b) {
            return a.rank_id - b.rank_id;
          });
          setUser(res.data.results);
          setpaginationNext(res.data);
          setAmoutData(res.data.count);
          setloadingTable(false);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");
            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    } else {
      setloadingTable(true);
      let offset = 25 * (pageNumber - 1);
      let paginationNext =
        process.env.REACT_APP_API_USERS + `?limit=25&offset=${offset}`;
      Axios.get(paginationNext, {
        headers: {
          Authorization: "Token " + Token,
        },
      })
        .then((res) => {
          setUser(res.data.results);
          setloadingTable(false);
          setpaginationNext(res.data);
          setAmoutData(res.data.count);
        })

        .catch((err) => {
          if (err.response.status === 401) {
            localStorage.removeItem("Token_");
            localStorage.removeItem("Token");
            navigate("/notfound404");
          }
          console.error(err);
          Swal.fire({
            icon: "error",
          });
        });
    }
  };
  return (
    <>
      <Layout>
        <div ref={topRef}>
          <Form>
            <style>
              {`
        .mr10 {margin-right: 10px;}
      `}
            </style>
            <div className="App login-box">
              <section
                style={{
                  backgroundImage: `url(${bg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100% 100%",
                  backgroundSize: "cover",
                  minHeight: "1180px",
                }}
              >
                <div className="mb-0 rounded" style={{ padding: "68px 0 0 0" }}>
                  <div className="row col-12 col-sm-12 ms-0 justify-content-center pt-3">
                    <div className="p-3">
                      <div
                        className="card col-sm-12 col-xs-12"
                        style={{ backgroundColor: "rgb(247, 247, 247, 0.68)" }}
                      >
                        <div className="card-body rounded">
                          <div className="row d-flex p-2 mt-2">
                            <div className="text-start col-1 col-sm-2 p-0 h-100 ">
                              <Link
                                to={`/PageHome`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                  display: "inline-block",
                                }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-primary m-0 d-none d-md-block px-4 "
                                  style={{
                                    backgroundColor: "rgb(2, 117, 216,0.80)",
                                    border: "none",
                                  }}
                                >
                                  ย้อนกลับ
                                </button>
                              </Link>
                              <Link to={`/PageHome`} className="d-md-none">
                                <FaArrowAltCircleLeft
                                  style={{ fontSize: "22px", color: "#3399FF" }}
                                  className="mt-2"
                                />
                              </Link>
                            </div>
                            <div
                              className=" col-10 col-sm-8 card-title text-center fs-5 fs-3 py-1"
                              style={{ color: "#000000" }}
                            >
                              <div
                                className="fw-bold"
                                style={{ fontSize: "21px" }}
                              >
                                ผลการทดสอบรายบุคคล
                              </div>
                            </div>
                            <div
                              className=" col-12 col-sm-12 text-center fw-bold mb-3"
                              style={{ fontSize: "16px" }}
                            ></div>
                            <hr></hr>
                          </div>
                          <div className="m-3">
                            <div
                              className="row d-flex justify-content-between fw-bold"
                              style={{ fontSize: "16px", color: "#616161" }}
                            >
                              <div className="row col-12 col-sm-9 ms-1">
                                <div
                                  className="col-12 col-sm-6 col-md-7 col-lg-5 d-flex align-items-sm-center justify-content-center"
                                  style={{ fontSize: "20px", color: "#616161" }}
                                >
                                  สังกัด : {DataToken_.work_unit}
                                </div>
                              </div>
                              <div className="col-12 col-sm-3 has-validation mt-2 mt-xl-0">
                                <div className="input-group">
                                  <input
                                    className="form-control"
                                    placeholder="ค้นหา / Search"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                  />
                                  {loadingSearch ? (
                                    <button
                                      className="input-group-text"
                                      style={{
                                        backgroundColor: "#FFB545",
                                        border: "none",
                                      }}
                                    >
                                      <Spinner
                                        as="span"
                                        animation="border"
                                        variant="light"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                      />
                                      กรุณารอสักครู่...
                                    </button>
                                  ) : (
                                    <button
                                      className="input-group-text"
                                      style={{
                                        backgroundColor: "#9ca0ca",
                                        fontWeight: "500",
                                      }}
                                      onClick={searchValue}
                                    >
                                      ค้นหา
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* <!-- Table  --> */}
                          <div className="overflow-auto">
                            {loadingTable ? (
                              <LoadingTable />
                            ) : User.length === 0 ? (
                              <CheckNoContent />
                            ) : (
                              <div style={{ height: "800px" }}>
                                <Table
                                  responsive
                                  className={
                                    isStacked
                                      ? "table-stacked"
                                      : "table_content table table-hover"
                                  }
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "16px",
                                          textAlign: "center",
                                          width: "20%",
                                          minWidth: "150px",
                                          backgroundColor: "#666699",
                                          height: "80px",
                                          color: "white",
                                        }}
                                      >
                                        <p>ชื่อ - นามสกุล</p>
                                      </th>
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "14px",
                                          width: "30%",
                                          minWidth: "250px",
                                          textAlign: "center",
                                          backgroundColor: "#8181B8",
                                          color: "white",
                                        }}
                                      >
                                        <p>ตำแหน่ง</p>
                                      </th>
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "14px",
                                          width: "10%",
                                          minWidth: "150px",
                                          textAlign: "center",
                                          backgroundColor: "#8181B8",
                                          color: "white",
                                        }}
                                      >
                                        <p>ผลการทดสอบ</p>
                                      </th>
                                      {/* <th scope="col" style={{ fontSize: "14px", width: "10%", minWidth: "150px", textAlign: "center", backgroundColor: "#8181B8", color: "white" }}><p>ใบ</p></th> */}
                                    </tr>
                                  </thead>
                                  <tbody
                                    style={{
                                      backgroundColor:
                                        "rgb(247, 247, 247, 0.5)",
                                    }}
                                  >
                                    {User.map((Data, i) => (
                                      <tr className="raw " key={i}>
                                        <td
                                          className="text-center text-lg-start pt-lg-3 ps-lg-2 "
                                          style={{
                                            fontSize: "16px",
                                            backgroundColor: "#d0d9ff",
                                          }}
                                          data-label="ชื่อ - นามสกุล"
                                        >
                                          {(pageNumber - 1) * 25 + i++ + 1}.{" "}
                                          {Data.full_name}
                                        </td>
                                        <td
                                          className="text-center"
                                          data-label="ตำแหน่ง"
                                          style={{ verticalAlign: "middle" }}
                                        >
                                          {Data.position}
                                        </td>
                                        <td
                                          className="text-center"
                                          data-label="ผลการทดสอบ"
                                          style={{
                                            backgroundColor: isStacked
                                              ? "RGB(2, 117, 216,0.10)"
                                              : "",
                                          }}
                                        >
                                          <ModalScore
                                            IdUser={Data.id}
                                            NoneImg={false}
                                          />
                                        </td>
                                        {/* <td className="text-center" data-label="ผลการทดสอบ">

                                                                            <ModalReport
                                                                                IdUser={Data.id}
                                                                            />
                                                                        </td> */}
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>{" "}
                              </div>
                            )}
                          </div>
                        </div>{" "}
                        <ModalPagination
                          pageNumber={pageNumber}
                          AmountPage={AmountPage}
                          handlePageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </Form>
        </div>
      </Layout>

      {/* )} */}
    </>
  );
};

export default PageScoreUser;
